const features = [
  {
    icon: 'ri-pages-line',
    title: '下拉式连续阅读',
    desc: '无需手动翻页，下滑即可无缝衔接下一章节，沉浸追漫不停歇，还原最舒适的阅读体验。',
  },
  {
    icon: 'ri-global-line',
    title: '海量多元题材',
    desc: '韩漫腐、日漫腐、国漫耽美全覆盖，校园、古风、奇幻、悬疑等题材一应俱全，总有一部让你心动。',
  },
  {
    icon: 'ri-shield-star-line',
    title: '纯净阅读环境',
    desc: '严格过滤恶意广告与弹窗干扰，全站绿色安全，只为给你一个安静纯粹的腐漫阅读空间。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日准时更新',
    desc: '编辑团队每日精选热门腐漫推荐，完结全集与新番连载同步跟进，不错过任何一部精彩作品。',
  },
  {
    icon: 'ri-device-line',
    title: '多端畅快追漫',
    desc: '桌面端与移动端自适应适配，无论是在电脑前还是通勤途中，随时随地打开即读，追漫不受限。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            平台特色
          </h2>
          <p className="mt-2 text-sm text-foreground-500">为什么腐漫爱好者都选择腐漫画网</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="group p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-accent-300 transition-all"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors">
                <i className={`${feat.icon} text-lg md:text-xl`}></i>
              </div>
              <h3 className="mt-4 text-sm md:text-base font-semibold text-foreground-900">
                {feat.title}
              </h3>
              <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}